<template>
  <div class="logistics-verification-details">
    <div class="logistics-verification-details-container">
      <div class="top-info">
        <div class="top-info-row">
          <span class="top-info-title">仓库名称：</span>
          <span class="top-info-content">{{ warehouseName }}</span>
        </div>
        <div class="top-info-row">
          <span class="top-info-title">承运商：</span>
          <span class="top-info-content express-info-content">
            <span>{{ expressName }}</span>
            <span class="express-tips" :class="`express-tips${type}`">{{ type == 1 ?'快递':'物流' }}</span>
          </span>
        </div>
        <div class="top-info-row">
          <span class="top-info-title">日期：</span>
          <span class="top-info-content">{{ billDate }}</span>
        </div>
      </div>

      <!-- 运单上传 -->
      <div class="details-row" :class="active === 1 ?'details-row-hign':''">
        <div class="details-row-left">
          <img class="step-img" :src="active === 1 ? signImgObj[active].hignImg : signSuccessImg">
          <span :class="active === 1 ? 'step-name-hign' :'step-name'">运单上传</span>
          <span v-if="uploadFileName" class="upload-file-name">（{{ uploadFileName }}）</span>
        </div>
        <div class="details-row-right" v-if="active === 1">
          <div class="down-btn interval" @click="downWaybillTmp('wallBillTmp')">
            <img class="down-img" :src="downImg">
            下载运单模板
          </div>
          <el-upload v-loading.fullscreen.lock="loading" element-loading-text="文件上传中"
            element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" class="upload"
            ref="upload" action="#" :show-file-list="false" :auto-upload="true" :before-upload="uploadWaybillExcel">
            <div class="upload-btn interval">
              <img class="upload-img" :src="uploadImg">
              导入运单
            </div>
          </el-upload>
          <el-button :class="!waybillIsUploadSuccess ?'btn-gray2':'btn-blue'" :disabled="!waybillIsUploadSuccess"
            @click="uploadWayBill">上传完成</el-button>
        </div>
      </div>
      <div class="vertical-line"></div>

      <!-- 手工单匹配 -->
      <div v-if="type === 1" class="handmade-order"
        :class="[isOpenObj.handmadeIsOpen ? 'open' : 'close', active === 2 ? 'handmade-order-hign' : '']">
        <div class="details-row" :class="active === 2 ?'details-row-hign':''">
          <div class="details-row-left">
            <img class="step-img"
              :src="active === 2 ? signImgObj[active].hignImg : (active > 2 ? signSuccessImg : signImgObj[2].img)">
            <span :class="active === 2 ? 'step-name-hign' : 'step-name'">手工单匹配</span>
            <span v-if="manualAccountsReceivableOBj.hasForceSkip" class="force-skip-sign">已强制跳过</span>
          </div>

          <div class="details-row-right">
            <div class="btn-container" v-if="active === 2">
              <div v-if=" manualAccountsReceivableOBj.processStep === 2" class="calculating-btn interval">
                <i class="el-icon-loading"></i>
                正在计算
              </div>
              <div v-if="isOpenManualOrderCalculatingBtn" class="calculating-btn interval">
                <i class="el-icon-loading"></i>
                正在初始化
              </div>
              <div v-if="!isOpenManualOrderCalculatingBtn" class="manual-order-btn">
                <div v-if="!manualAccountsReceivableOBj.hasForceSkip && manualAccountsReceivableOBj.processStep < 2"
                  class="force-skip-btn interval" @click="forceSkip">
                  <img class="force-skip-img" src="~assets/images/logistics-verification/red-success.png">
                  强制跳过
                </div>
                <el-button v-if="manualAccountsReceivableOBj.processStep < 2" class="interval"
                  :class="!manualAccountsReceivableOBj.hasForceSkip && (unregisteredHandmadeOrderList.length !== 0 ? true : false) ?'btn-gray2':'btn-blue'"
                  :disabled="!manualAccountsReceivableOBj.hasForceSkip && (unregisteredHandmadeOrderList.length !== 0?true:false)"
                  @click="matchingCompleted">匹配完成</el-button>
              </div>
            </div>

            <div class="collapse-btn" @click="isOpen('handmadeIsOpen')">
              <img :class="isOpenObj.handmadeIsOpen?'open-arrow':'collapse-arrow'" class="arrow-img" :src="arrowImg">
              {{ !isOpenObj.handmadeIsOpen ?'展开':'收起' }}
            </div>
          </div>
        </div>

        <div class="details-content">
          <div class="handmade-info">
            <div class="handmade-info-row">
              <div class="handmade-info-title handmade-info-btn">
                手工单单量
                <div v-if="active === 2" class="refresh-btn" @click="refreshHandmadeOrder">
                  <img class="refresh-img" src="~assets/images/refresh/refresh-hign.png">
                  <span>刷新</span>
                </div>
                <div class="to-handmade" @click="toUrl" v-if="unregisteredHandmadeOrderList.length && active === 2">
                  <img class="small-aircraft" src="~assets/images/logistics-verification/small-aircraft.png">
                  <span>前往手工单登记</span>
                </div>
              </div>
              <div class="handmade-info-content">{{ manualAccountsReceivableOBj.totalOrderNum }}</div>
            </div>
            <div class="handmade-info-row">
              <div class="handmade-info-title">已登手工单单量</div>
              <div class="handmade-info-content">{{ manualAccountsReceivableOBj.registerOrderNum }}</div>
            </div>
            <div class="handmade-info-row">
              <div class="handmade-info-title">未登手工单单量</div>
              <div class="handmade-info-content">{{ manualAccountsReceivableOBj.totalOrderNum -
                manualAccountsReceivableOBj.registerOrderNum }}</div>
            </div>
            <div class="handmade-info-row">
              <div class="handmade-info-title">手工单金额</div>
              <div class="handmade-info-content">{{ manualAccountsReceivableOBj.accountAmount }}</div>
            </div>
          </div>

          <!-- 已登记手工单列表 -->
          <div class="registration-handmade">
            <el-table ref="table" :data="registrationHandmadeOrderTableData" style="width: 100%">
              <el-table-column v-for="(item, index) in registrationHandmadeOrderTableTitleList" :key="index"
                :prop="item.prop" :label="item.label" show-overflow-tooltip :min-width="item.width">
              </el-table-column>

              <div v-if="manualAccountsReceivableOBj.processStep === 2" slot="empty" class="empty">
                <span>正在计算中，请稍等</span>
              </div>
            </el-table>
          </div>

          <!-- 未登记手工单列表 -->
          <p class="unregistered-handmade-title" v-if="unregisteredHandmadeOrderList.length">未登手工单单号：</p>
          <div class="unregistered-handmade-order">
            <div class="unregistered-handmade-order-row" v-for="(item, index) in unregisteredHandmadeOrderList"
              :key="index">
              {{ item }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="type === 1" class="vertical-line"></div>

      <!-- 重量校对 -->
      <div v-if="type === 1" class="handmade-order"
        :class="[isOpenObj.weightSchoolTeamIsOpen ? 'open' : 'close', active === 3 ?'handmade-order-hign':'']">
        <div class="details-row" :class="active === 3 ? 'details-row-hign' : ''">
          <div class="details-row-left">
            <img class="step-img"
              :src="active === 3 ? signImgObj[active].hignImg : (active > 3 ? signSuccessImg : signImgObj[3].img)">
            <span :class="active === 3 ? 'step-name-hign' : 'step-name'">重量校对</span>
          </div>

          <div class="details-row-right">
            <div class="btn-container" v-if="active === 3">
              <div v-if="expressAccountsReceivableObj.processStep === 1" class="calculating-btn interval">
                <i class="el-icon-loading"></i>
                正在计算
              </div>

              <div v-if="!expressAccountsReceivableObj.processStep" class="calculating-btn interval">
                <i class="el-icon-loading"></i>
                正在初始化
              </div>
            </div>

            <div class="collapse-btn" @click="isOpen('weightSchoolTeamIsOpen')">
              <img :class="isOpenObj.weightSchoolTeamIsOpen ? 'open-arrow' : 'collapse-arrow'" class="arrow-img"
                :src="arrowImg">
              {{ !isOpenObj.weightSchoolTeamIsOpen ? '展开' : '收起' }}
            </div>
          </div>
        </div>

        <div class="details-content">
          <div class="handmade-info weight-info">
            <div class="handmade-info-row">
              <div class="handmade-info-title">
                已匹配运单量
              </div>
              <div class="handmade-info-content">{{ expressAccountsReceivableObj.totalOrderNum }}</div>
            </div>
            <div class="handmade-info-row">
              <div class="handmade-info-title">差异单量</div>
              <div class="handmade-info-content">{{ expressAccountsReceivableObj.totalDiffOrderNum }}</div>
            </div>
            <div class="handmade-info-row">
              <div class="handmade-info-title">差异单量金额</div>
              <div class="handmade-info-content">{{ expressAccountsReceivableObj.totalDiffOrderAmount }}</div>
            </div>
            <div class="handmade-info-row">
              <div class="handmade-info-title">金额</div>
              <div class="handmade-info-content">{{ expressAccountsReceivableObj.totalOrderAmount }}</div>
            </div>
          </div>

          <!-- 重量校对列表 -->
          <div class="registration-handmade">
            <el-table ref="table" :data="expressAccountsReceivableTableData" style="width: 100%">
              <el-table-column v-for="(item, index) in weightTableTitleList" :key="index" :prop="item.prop"
                :label="item.label" show-overflow-tooltip :min-width="item.width">
                <template slot-scope="scope">
                  <div v-if="item.prop === 'diffOrderCount'" class="diff-order-count">
                    <span>{{ scope.row.diffOrderCount }}</span>
                    <div class="down-diff-order-count" @click="downDiffOrderCount(scope.row)">
                      <img class="down-diff-order-count-img" :src="downHignImg">
                      下载
                    </div>
                  </div>
                  <div v-else>{{ scope.row[item.prop] }}</div>
                </template>
              </el-table-column>
              <div v-if="expressAccountsReceivableObj.processStep === 1" slot="empty" class="empty">
                <span>正在计算中，请稍等</span>
              </div>
            </el-table>
          </div>
        </div>
      </div>
      <div v-if="type === 1" class="vertical-line"></div>

      <!-- 物流加收费 -->
      <div v-if="type === 1" class="handmade-order"
        :class="[isOpenObj.logisticsPlusChargesIsOpen ? 'open' : 'close', active === 4 ? 'handmade-order-hign' : '']">
        <div class="details-row" :class="active === 4 ? 'details-row-hign' : ''">
          <div class="details-row-left">
            <img class="step-img"
              :src="active === 4 ? signImgObj[active].hignImg : (active > 4 ? signSuccessImg : signImgObj[4].img)">
            <span :class="active === 4 ? 'step-name-hign' : 'step-name'">物流加收费</span>
          </div>

          <div class="details-row-right">
            <div class="btn-container" v-if="active === 4">
              <div v-if="surchargeAccountReceivableObj.processStep === 1" class="calculating-btn interval">
                <i class="el-icon-loading"></i>
                正在计算
              </div>
              <div class="down-tmp-btn interval" @click="downWaybillTmp('logisticsPlusCharges')">
                <img class="down-img" :src="downImg">
                下载模板
              </div>
              <el-upload v-if="surchargeAccountReceivableObj.processStep !== 1" class="upload" ref="upload" action="#"
                :show-file-list="false" :auto-upload="true" :before-upload="uploadSurchargebillExcel">
                <div class="upload-tmp-btn interval">
                  <img class="upload-img" :src="uploadImg">
                  导入
                </div>
              </el-upload>
            </div>

            <div class="collapse-btn" @click="isOpen('logisticsPlusChargesIsOpen')">
              <img :class="isOpenObj.logisticsPlusChargesIsOpen ? 'open-arrow' : 'collapse-arrow'" class="arrow-img"
                :src="arrowImg">
              {{ !isOpenObj.logisticsPlusChargesIsOpen ? '展开' : '收起' }}
            </div>
          </div>
        </div>

        <div class="details-content">
          <!-- 物流加收费列表 -->
          <div class="registration-handmade">
            <el-table ref="table" :data="logisticsPlusChargesTableData" style="width: 100%">
              <el-table-column v-for="(item, index) in logisticsPlusChargesTableTitleList" :key="index"
                :prop="item.prop" :label="item.label" show-overflow-tooltip :min-width="item.width">
              </el-table-column>

              <div v-if="surchargeAccountReceivableObj.processStep === 1" slot="empty" class="empty">
                <span>正在计算中，请稍等</span>
              </div>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 金额校对 -->
      <div v-if="type === 2" class="handmade-order"
        :class="[isOpenObj.amountVerificationIsOpen ? 'open' : 'close', active === 2 ? 'handmade-order-hign' : '']">
        <div class="details-row" :class="active === 2 ? 'details-row-hign' : ''">
          <div class="details-row-left">
            <img class="step-img"
              :src="active === 2 ? signImgObj[2].hignImg : (active > 2 ? signSuccessImg : signImgObj[2].img)">
            <span :class="active === 2 ? 'step-name-hign' : 'step-name'">金额校对</span>
          </div>

          <div class="details-row-right">
            <div class="btn-container" v-if="active === 2">
              <div v-if="expressAccountsReceivableObj.processStep === 1" class="calculating-btn interval">
                <i class="el-icon-loading"></i>
                正在计算
              </div>

              <div v-if="!expressAccountsReceivableObj.processStep" class="calculating-btn interval">
                <i class="el-icon-loading"></i>
                正在初始化
              </div>
            </div>

            <div class="collapse-btn" @click="isOpen('amountVerificationIsOpen')">
              <img :class="isOpenObj.amountVerificationIsOpen ? 'open-arrow' : 'collapse-arrow'" class="arrow-img"
                :src="arrowImg">
              {{ !isOpenObj.amountVerificationIsOpen ? '展开' : '收起' }}
            </div>
          </div>
        </div>

        <div class="details-content">
          <div class="handmade-info weight-info">
            <div class="handmade-info-row">
              <div class="handmade-info-title">
                物流运单量
              </div>
              <div class="handmade-info-content">{{ expressAccountsReceivableObj.totalOrderNum }}</div>
            </div>
            <div class="handmade-info-row">
              <div class="handmade-info-title">金额</div>
              <div class="handmade-info-content">{{ expressAccountsReceivableObj.totalOrderAmount }}</div>
            </div>
          </div>

          <!-- 金额校对列表 -->
          <div class="registration-handmade">
            <el-table ref="table" :data="expressAccountsReceivableTableData" style="width: 100%">
              <el-table-column v-for="(item, index) in amountVerificationTableTitleList" :key="index" :prop="item.prop"
                :label="item.label" show-overflow-tooltip :min-width="item.width">
                <template slot-scope="scope">
                  <div v-if="item.prop === 'diffOrderCount'" class="diff-order-count">
                    <span>{{ scope.row.diffOrderCount }}</span>
                    <div class="down-diff-order-count" @click="downDiffOrderCount(scope.row)">
                      <img class="down-diff-order-count-img" :src="downHignImg">
                      下载
                    </div>
                  </div>
                  <div v-else>{{ scope.row[item.prop] }}</div>
                </template>
              </el-table-column>

              <div v-if="expressAccountsReceivableObj.processStep === 1" slot="empty" class="empty">
                <span>正在计算中，请稍等</span>
              </div>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <div class="logistics-verification-footer">
      <div class="total-info">
        <div class="total-amount">
          <span class="total-amount-title">合计：</span>
          <span class="total-amount-content">{{ accountAmount }}</span>
        </div>
        <div class="total-details" v-if="type === 1">
          （
          <span class="express-cost">快递费：{{ logisticIncome }}</span>
          <span>物流加收费：{{ surchargeIncome }}</span>
          ）
        </div>
      </div>
      <el-button v-if="(type === 1 && active === 5) || (type === 2 && active === 4)" class="btn-blue"
        @click="verificationCompleted">核验完成</el-button>
    </div>
  </div>
</template>

<script>
import LogisticsVerification from "models/logistics-verification";
import { downLoadFile, numsToRMBSymbolAndMillimeter, downLoadFileByBlob } from "common/js/util";
export default {

  data() {
    return {
      // 1：快递； 2：物流
      type: null,
      // 物流核验记录id
      logisticsVerificationId: null,
      warehouseName: '',
      expressName: '',
      billDate: '',
      // 总账单金额（合计）
      accountAmount: 0,
      // 快递费（合计中）
      logisticIncome: 0,
      // 物流加收费（合计中）
      surchargeIncome: 0,
      // 物流核验步骤（0、已创建; 1、账单上传完成; 2、手工单核验完成; 3、重量/金额核验完成; 4、加收费核验完成; 5、物流核验完成)
      active: 0,
      signSuccessImg: require('@/assets/images/logistics-verification/check-circle.png'),
      signImgObj: {
        1: {
          hignImg: require('@/assets/images/logistics-verification/filled-number-1.png')
        },
        2: {
          img: require('@/assets/images/logistics-verification/hollow-number-2.png'),
          hignImg: require('@/assets/images/logistics-verification/filled-number-2.png')
        },
        3: {
          img: require('@/assets/images/logistics-verification/hollow-number-3.png'),
          hignImg: require('@/assets/images/logistics-verification/filled-number-3.png')
        },
        4: {
          img: require('@/assets/images/logistics-verification/hollow-number-4.png'),
          hignImg: require('@/assets/images/logistics-verification/filled-number-4.png')
        }
      },
      downImg: require('@/assets/images/upload/upload-bottom.png'),
      downHignImg: require('@/assets/images/upload/upload-bottom-hign.png'),
      uploadImg: require('@/assets/images/home/upload.png'),
      arrowImg: require('@/assets/images/arrow/arrow-bottom-hign.png'),

      // 运单是否上传成功
      waybillIsUploadSuccess: false,
      loading: false,
      uploadFileName: '',
      /* 导入的流 */
      formData: null,
      isOpenActiveObj: {
        2: 'handmadeIsOpen',
        3: 'weightSchoolTeamIsOpen',
        4: 'logisticsPlusChargesIsOpen'
      },
      isOpenObj: {
        // 手工单是否展开
        handmadeIsOpen: false,
        // 重量校对是否展开
        weightSchoolTeamIsOpen: false,
        // 物流加收费是否展开
        logisticsPlusChargesIsOpen: false,
        // 金额校对是否展开
        amountVerificationIsOpen: false,
      },

      // 手工单为null时，开启正在计算按钮
      isOpenManualOrderCalculatingBtn: false,
      // 手工单基本信息
      manualAccountsReceivableOBj: {
        // 手工单账单id
        id: null,
        // 总手工单单量
        totalOrderNum: null,
        // 已登记的手工单单量
        registerOrderNum: null,
        // 手工单账单金额
        accountAmount: null,
        // 手工单是否强制跳过
        hasForceSkip: false,
        // 流程步骤（1、初始化完成 2、完成匹配 3、计算运费完成）
        processStep: 1,
      },
      // 手工单项目账单明细列表
      registrationHandmadeOrderTableData: [],
      registrationHandmadeOrderTableTitleList: [
        { label: '项目名称', prop: 'projectName', width: '', alignment: 'left' },
        { label: '科目', prop: 'subjectName', width: '', alignment: 'left' },
        { label: '金额', prop: 'amount', width: '', alignment: 'left' }
      ],
      // 未登记手工单
      unregisteredHandmadeOrderList: [],

      // 重量/金额校对基本信息
      expressAccountsReceivableObj: {
        // 重量/金额校对账单id
        id: null,
        // 1、初始化匹配完成 2、计算运费完成
        processStep: null,
        // 总差异金额
        totalDiffOrderAmount: null,
        // 总差异单量
        totalDiffOrderNum: null,
        // 总差异金额
        totalOrderAmount: null,
        // 总单量
        totalOrderNum: null
      },
      expressAccountsReceivableTableData: [],
      weightTableTitleList: [
        { label: '项目名称', prop: 'projectName', width: '', alignment: 'left' },
        { label: '已匹配运单量', prop: 'orderNumber', width: '', alignment: 'left' },
        { label: '差异单量', prop: 'diffOrderCount', width: '', alignment: 'left' },
        { label: '差异单量金额', prop: 'diffAmount', width: '', alignment: 'left' },
        { label: '科目', prop: 'subjectName', width: '', alignment: 'left' },
        { label: '金额', prop: 'amount', width: '', alignment: 'left' }
      ],

      // 物流加收费基本信息
      surchargeAccountReceivableObj: {
        // 加收费账单id
        id: null,
        // 1、已上传 2、计算完成
        processStep: 0
      },
      // 物流加收费列表数据
      logisticsPlusChargesTableData: [],
      logisticsPlusChargesTableTitleList: [
        { label: '项目名称', prop: 'projectName', width: '', alignment: 'left' },
        { label: '科目', prop: 'subjectName', width: '', alignment: 'left' },
        { label: '金额', prop: 'amount', width: '', alignment: 'left' }
      ],

      // 金额校对列表数据
      amountVerificationTableTitleList: [
        { label: '项目名称', prop: 'projectName', width: '', alignment: 'left' },
        { label: '物流运单量', prop: 'orderNumber', width: '', alignment: 'left' },
        { label: '差异单量', prop: 'diffOrderCount', width: '', alignment: 'left' },
        { label: '差异单量金额', prop: 'diffAmount', width: '', alignment: 'left' },
        { label: '科目', prop: 'subjectName', width: '', alignment: 'left' },
        { label: '金额', prop: 'amount', width: '', alignment: 'left' }
      ]
    }
  },

  watch: {
    '$route': {
      handler(v) {
        if (this.logisticsVerificationId !== v.query.logisticsVerificationId && v.name === 'logisticsVerificationDetails/:name') {
          this.type = Number(v.query.type)
          this.logisticsVerificationId = v.query.logisticsVerificationId
          this.initDetails()
        }
      },
      deep: true,
    }
  },

  created() {
    this.type = Number(this.$route.query.type)
    this.logisticsVerificationId = this.$route.query.logisticsVerificationId
    this.initDetails()
  },

  deactivated() {
    this.type = null
    this.logisticsVerificationId = null
  },

  methods: {
    initDetails() {
      let logisticsVerificationId = this.logisticsVerificationId
      LogisticsVerification.postLogisticsVerificationDetails(logisticsVerificationId).then(res => {
        if (res.success) {
          let { accountsReceivable, expressAccountsReceivable, manualAccountsReceivable, surchargeAccountReceivable } = res.result

          let { accountMonth, expressName, warehouseName, accountAmount, 
            logisticIncome, surchargeIncome, processStep, fileName } = accountsReceivable
          this.uploadFileName = fileName
          this.billDate = accountMonth
          this.expressName = expressName
          this.warehouseName = warehouseName
          this.accountAmount = accountAmount ? numsToRMBSymbolAndMillimeter(accountAmount): 0
          this.logisticIncome = logisticIncome ? numsToRMBSymbolAndMillimeter(logisticIncome) : 0
          this.surchargeIncome = surchargeIncome ? numsToRMBSymbolAndMillimeter(surchargeIncome) : 0
          this.active = processStep + 1
          
          // 自动展开功能
          let steps = null
          if (this.type === 1) {
            steps = this.isOpenActiveObj[this.active]
          } else {
            if (this.active === 2) steps = 'amountVerificationIsOpen'
          }
          this.isOpen(steps)

          // 手工单账单
          this.commonManualInfo(manualAccountsReceivable)

          // 重量/金额校对账单
          if (expressAccountsReceivable) {
            let { totalDiffOrderAmount, totalDiffOrderNum, totalOrderAmount, 
              totalOrderNum, detailList } = expressAccountsReceivable
            let expressAccountsReceivableObj = {
              // 总单量
              totalOrderNum,
              // 总差异单量
              totalDiffOrderNum,
              // 重量/金额校对账单id
              id: expressAccountsReceivable.id,
              // 1、初始化匹配完成 2、计算运费完成
              processStep: expressAccountsReceivable.processStep,
              // 总差异金额
              totalOrderAmount: numsToRMBSymbolAndMillimeter(totalOrderAmount),
              // 总差异金额
              totalDiffOrderAmount: numsToRMBSymbolAndMillimeter(totalDiffOrderAmount)
            }
            this.expressAccountsReceivableObj = expressAccountsReceivableObj
            let expressAccountsReceivableTableData = []
            detailList.map(i => {
              let obj = {}
              obj.logisticsExpressAccountsReceivableId = i.logisticsExpressAccountsReceivableId
              obj.projectId = i.projectId
              obj.projectName = i.projectName
              obj.subjectName = i.feeDetailName
              obj.diffOrderCount = i.diffOrderNumber
              obj.orderNumber = i.orderNumber
              obj.amount = numsToRMBSymbolAndMillimeter(i.accountAmount)
              obj.diffAmount = numsToRMBSymbolAndMillimeter(i.diffAccountAmount)
              expressAccountsReceivableTableData.push(obj)
            })
            this.expressAccountsReceivableTableData = expressAccountsReceivableTableData
          } else {
            this.expressAccountsReceivableObj = {
              // 重量/金额校对账单id
              id: null,
              // 1、初始化匹配完成 2、计算运费完成
              processStep: null,
              // 总差异金额
              totalDiffOrderAmount: '--',
              // 总差异单量
              totalDiffOrderNum: 0,
              // 总差异金额
              totalOrderAmount: '--',
              // 总单量
              totalOrderNum: 0
            }
          }

          // 物流加收费
          if (surchargeAccountReceivable) {
            let surchargeAccountReceivableObj = {
              // 加收费账单id
              id: surchargeAccountReceivable.id,
              // 1、已上传 2、计算完成
              processStep: surchargeAccountReceivable.processStep
            }
            this.surchargeAccountReceivableObj = surchargeAccountReceivableObj
  
            let logisticsPlusChargesTableData = []
            surchargeAccountReceivable.detailList.map(i => {
              let obj = {}
              obj.projectName = i.projectName
              obj.subjectName = i.feeDetailName
              obj.amount = numsToRMBSymbolAndMillimeter(i.accountAmount)
              logisticsPlusChargesTableData.push(obj)
            })
            this.logisticsPlusChargesTableData = logisticsPlusChargesTableData
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /** 
     * @description 是否展开
    */
    isOpen(key) {
      let keyArr = Object.keys(this.isOpenObj)
      keyArr.map(i => {
        if (i === key) {
          this.isOpenObj[key] = !this.isOpenObj[key]
        } else {
          this.isOpenObj[i] = false
        }
      })
    },

    /** 
     * @desc 下载运单模板
     * @param {*} key 模板类型
    */
    downWaybillTmp(key) {
      let url
      let fileName
      if (key === 'wallBillTmp') {
        fileName = '承运商导入模板'
        if (this.type === 1) {
          // 快递
          url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/%E6%89%BF%E8%BF%90%E5%95%86%E8%B4%A6%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
        } else {
          // 金额校队
          url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/%E6%89%BF%E8%BF%90%E5%95%86%E9%87%91%E9%A2%9D%E6%A0%B8%E9%AA%8C%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
        }
      } else if (key === 'logisticsPlusCharges') {
        // 物流加收费
        fileName = '物流加收费导入模板'
        url = 'https://zzd-fire-test.oss-cn-hangzhou.aliyuncs.com/zzd/excelModel/%E9%80%80%E4%BB%B6%E6%8B%A6%E6%88%AA%E8%B4%B9%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx'
      }
      downLoadFile(fileName, url)
    },

    /** 
     * @description 导入运单
    */
    uploadWaybillExcel(file) {
      this.loading = true
      var formData = new FormData();
      formData.append("file", file);
      formData.append("logisticsAccountsReceivableId", this.logisticsVerificationId);
      this.formData = formData
      this.uploadFileName = file.name
      if (file) {
        this.loading = false
        this.waybillIsUploadSuccess = true
      }
      return false;
    },

    /** 
     * @description 导入加收费
    */
    uploadSurchargebillExcel(file) {
      this.loading = true
      var formData = new FormData();
      formData.append("file", file);
      formData.append("logisticsAccountsReceivableId", this.logisticsVerificationId);
      LogisticsVerification.postUploadLogisticsSurchargeBillExcel(formData).then(res => {
        if (res.success) {
          this.$message.success("加收费导入成功");
          this.loading = false
          this.initDetails()
        } else {
          this.$message.error(res.message)
        }
      })
      return false;
    },

    /** 
     * @description 导入运单模板
    */
    uploadWayBill() {
      let formData = this.formData
      if (formData.get('logisticsAccountsReceivableId')) {
        formData.delete('logisticsAccountsReceivableId')
      }
      formData.append("logisticsAccountsReceivableId", this.logisticsVerificationId);
      if (this.type === 1) {
        // 快递
        LogisticsVerification.postUploadExpressBillExcel(formData).then(res => {
          if (res.success) {
            this.$message.success("快递承运商运单导入成功");
            this.initDetails()
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        // 物流金额校对
        LogisticsVerification.postUploadLogisticsBillExcel(formData).then(res => {
          if (res.success) {
            this.$message.success("物流承运商运单导入成功");
            this.initDetails()
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },

    /** 
     * @description 跳转物流补登
    */
    toUrl() {
      this.$router.push({
        path: '/production/bulk/logistics-supplementary-registration'
      })
    },

    /** 
     * @description 手工单信息处理
    */
    commonManualInfo(manualAccountsReceivable) {
      this.isOpenManualOrderCalculatingBtn = false
      if (manualAccountsReceivable) {
        let { totalOrderNum, registerOrderNum, hasForceSkip, exceptionExpressNos, detailList } = manualAccountsReceivable
        let manualAccountsReceivableOBj = {
          hasForceSkip,
          // 总手工单单量
          totalOrderNum,
          // 已登记的手工单单量
          registerOrderNum,
          // 手工单账单id
          id: manualAccountsReceivable.id,
          processStep: manualAccountsReceivable.processStep,
          // 手工单账单金额
          accountAmount: numsToRMBSymbolAndMillimeter(manualAccountsReceivable.accountAmount)
        }
        this.manualAccountsReceivableOBj = manualAccountsReceivableOBj
        this.unregisteredHandmadeOrderList = exceptionExpressNos
        let registrationHandmadeOrderTableData = []
        detailList.map(i => {
          let obj = {}
          obj.projectName = i.projectName
          obj.subjectName = i.feeDetailName
          obj.amount = numsToRMBSymbolAndMillimeter(i.accountAmount)
          registrationHandmadeOrderTableData.push(obj)
        })
        this.registrationHandmadeOrderTableData = registrationHandmadeOrderTableData
      } else {
        this.manualAccountsReceivableOBj = {
          // 手工单账单id
          id: null,
          // 总手工单单量
          totalOrderNum: 0,
          // 已登记的手工单单量
          registerOrderNum: 0,
          // 手工单账单金额
          accountAmount: '--',
          // 手工单是否强制跳过
          hasForceSkip: false,
          // 流程步骤（1、初始化完成 2、完成匹配 3、计算运费完成）
          processStep: 1
        }
        this.isOpenManualOrderCalculatingBtn = true
      }
    },

    /** 
     * @description 手工单--刷新手工单
    */
    refreshHandmadeOrder() {
      LogisticsVerification.postManuallyRefresh(this.manualAccountsReceivableOBj.id).then(res => {
        if (res.success) {
          this.commonManualInfo(res.result)
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /** 
     * @desc 手工单--强制跳过
    */
    forceSkip() {
      this.$confirm("强制跳过后，当前环节数据不可修改，请确认", "强制跳过", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        LogisticsVerification.postManualOrderForceSkip(this.manualAccountsReceivableOBj.id).then(res => {
          if (res.success) {
            this.commonManualInfo(res.result)
          } else {
            this.$message.error(res.message)
          }
        })
      });
    },

    /** 
     * @desc 手工单--匹配完成
    */
    matchingCompleted() {
      this.$confirm("完成后，将进入“重量校验”步骤，请确认", "确认完成", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        LogisticsVerification.postManuallyOrderCompleteMatching(this.manualAccountsReceivableOBj.id).then(res => {
          if (res.success) {
            this.commonManualInfo(res.result)
            this.action = 3
          } else {
            this.$message.error(res.message)
          }
        })
      });
    },

    /** 
     * @description 下载重量/金额差异单量
    */
    downDiffOrderCount(row) {
      let data = {
        id: row.logisticsExpressAccountsReceivableId,
        projectId: row.projectId
      }
      LogisticsVerification.postDownloadExpressDiffOrder(data).then(res => {
        downLoadFileByBlob(res)
      })
    },

    /** 
     * @desc 核验完成
    */
    verificationCompleted() {
      this.$confirm("完成后，当前核验流程将结束，请确认", "核验完成", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        LogisticsVerification.postCompleteVerification(this.logisticsVerificationId).then(res => {
          if (res.success) {
            this.initDetails()
          } else {
            this.$message.error(res.message)
          }
        })
      });
    }
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/finance/logistics-verification-details.scss';
</style>
